import { useQuery } from '@tanstack/react-query';

import { plantNameQueryOptions } from '../../../../plants';

export const usePlantLabel = (plantId: string | null): string | null => useQuery(plantNameQueryOptions(plantId)).data ?? null;
